"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RebrandingWhatsapp = function RebrandingWhatsapp(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#4C5559' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation),
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21.808 25.808c2.952.705 4.19-.886 4.665-2.125.291-.766 0-1.652-.766-2.005l-2.004-1.008c-.705-.292-1.482-.182-1.956.413l-.413.474c-.413.474-1.117.704-1.713.474-2.6-.948-4.02-2.843-4.664-3.9-.292-.534-.292-1.239.06-1.773l.414-.535c.291-.473.413-1.117.182-1.652l-1.118-2.478c-.413-.765-1.36-1.178-2.126-.887-1.36.656-2.952 1.956-1.652 5.32 2.126 5.322 6.33 8.456 11.115 9.695l-.024-.013Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.543,
    d: "M33.069 19.747c-.583 7.35-6.536 13.29-13.885 13.848-3.693.28-7.13-.765-9.9-2.709l-5.041.948c-.753.146-1.385-.559-1.179-1.3l1.47-5.114a15.045 15.045 0 0 1-1.64-7.738C3.32 9.92 9.746 3.652 17.508 3.409c8.99-.292 16.278 7.264 15.56 16.338Z",
    clipRule: "evenodd"
  }));
};
var _default = exports["default"] = RebrandingWhatsapp;